import { render, staticRenderFns } from "./Scroller.vue?vue&type=template&id=283485f5&scoped=true"
import script from "./Scroller.vue?vue&type=script&lang=js"
export * from "./Scroller.vue?vue&type=script&lang=js"
import style0 from "./Scroller.vue?vue&type=style&index=0&id=283485f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283485f5",
  null
  
)

export default component.exports